import { gql } from '@apollo/client/core';
import { Trans } from '@lingui/macro';
import React from 'react';
import useProduct from './useProduct';
import convertUnits from '../helpers/convertUnits';

import { Label, Value, Wrapper } from '../Base/DynamicComponent';

/**
 * @param {object} props
 * @param {object} [props.product]
 * @param {string} [props.unit]
 * @param {object} [props.style]
 * @param {...import('../Base/DynamicComponent').DynamicComponent} [props.rest]
 * @returns
 */
const baseUnit = 'cm';
export default function BottleDiameter({
  product: data,
  unit = baseUnit,
  style,
  ...rest
}) {
  const rawProduct = useProduct(data);
  const product = afterQuery(rawProduct);
  if (!hasContent(product)) return null;
  const displayValue = convertUnits({
    value: product.bottleDiameter,
    from: baseUnit,
    to: unit,
  });

  return (
    <Wrapper style={style} {...rest}>
      <Label {...rest}>
        <Trans>Bottle Diameter</Trans>
      </Label>
      <Value {...rest}>
        {displayValue.value} {displayValue.unit}
      </Value>
    </Wrapper>
  );
}

BottleDiameter.hasContent = hasContent;

function hasContent({ bottleDiameter }) {
  return !!bottleDiameter;
}

function afterQuery(product) {
  return {
    ...product,
    bottleDiameter: product?.bottleVariants?.[0]?.bottleDiameter,
  };
}

BottleDiameter.fragment = gql`
  fragment BottleDiameter on Product {
    bottleVariants {
      bottleDiameter
    }
  }
`;
